export default __webpack_public_path__ + "static/windscribe-firefox-extension-20f55a0035ea76ee1d1afc07e044d59a.png";